export default "__VITE_ASSET__CODOT71N__"